// extracted by mini-css-extract-plugin
export default {"section":"Section_section__BRbc2","halfSection":"Section_halfSection__85am+","sectionSM":"Section_sectionSM__u6omb","sectionMD":"Section_sectionMD__YTO7Y"};